module.exports = __webpack_public_path__ + "static/OpenSans-Bold-f87c7980e3c04b47aec2e1c182308aeb.woff";